import React from "react";
import { Helmet } from "react-helmet";
import AboutMe from "../components/About/AboutMe";

const AboutMePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>About — Adeolu Adegbemi | The Blueprint Architect</title>
        <meta
          name="description"
          content="Meet Adeolu Adegbemi — The Blueprint Architect. COREN-registered engineer, pastor and entrepreneur who helps professionals design repeatable systems to grow income, steward resources, and multiply impact."
        />
        <meta
          name="keywords"
          content="Adeolu Adegbemi, The Blueprint Architect, About, Biography, COREN Engineer, Pastor, Entrepreneur, Faith and Finance, Systems Thinking, Personal Brand"
        />
        <meta name="author" content="Adeolu Adegbemi" />

        {/* Open Graph */}
        <meta property="og:type" content="profile" />
        <meta property="og:url" content="https://adeoluadegbemi.com/about" />
        <meta
          property="og:title"
          content="About Adeolu Adegbemi — The Blueprint Architect"
        />
        <meta
          property="og:description"
          content="I help professionals build wealth without losing purpose — by translating engineering precision into practical blueprints for income, stewardship and impact."
        />
        <meta
          property="og:image"
          content="https://adeoluadegbemi.com/og-image-about.jpg"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://adeoluadegbemi.com/about"
        />
        <meta
          property="twitter:title"
          content="About Adeolu Adegbemi — The Blueprint Architect"
        />
        <meta
          property="twitter:description"
          content="COREN-registered Engineer, Pastor and Entrepreneur. Discover how practical blueprints can turn your skills into sustainable income and kingdom impact."
        />
        <meta
          property="twitter:image"
          content="https://adeoluadegbemi.com/twitter-image-about.jpg"
        />

        {/* Canonical + robots */}
        <link rel="canonical" href="https://adeoluadegbemi.com/about" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <main>
        <AboutMe />
      </main>
    </>
  );
};

export default AboutMePage;
